<script>
import { mapState } from "vuex";

import cycleMixin from "@/mixins/cycleMixin";

export default {
  mixins: [cycleMixin],

  computed: {
    ...mapState("payable", ["payable"])
  }
};
</script>

<template>
  <div class="total">
    <span>Total</span>

    <div class="amount">{{ payable | cycleTotal }}</div>
  </div>
</template>

<style scoped>
.total {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

span {
  font-size: 20px;
  font-weight: 500;
}

.amount {
  width: 100%;
  font-weight: 500;
  text-align: end;
  color: #af006b;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/CheckoutMobile/Payable/CycleComponents/Total.vue